import React from "react";
import Button from "@mui/material/Button";
import {
  MARK_AS_ADMIN,
  EDIT,
  REMOVE,
  CANCEL,
  LOG_OUT,
} from "../../constants/constant";
import { capitalize } from "@mui/material";

const ButtonCta1 = ({
  endIcon,
  startIcon,
  disabled,
  text,
  children,
  onClick,
  variant,
  color = "#fff",
  bgColor = "#f7954c",
  width,
  height,
  customStyles,
   sx = {},
}) => {
  const containedBtn = {
    width: width ? width : "auto",
    height: height ? height : "auto",
    borderRadius: "4px",
    boxShadow: "none",
    textTransform: "capitalize",
    // backgroundColor:
    //   text?.toLowerCase() === CANCEL?.toLowerCase()
    //     ? "#d8d8d8"
    //     : text?.toLowerCase() === LOG_OUT?.toLowerCase()
    //     ? "#e51818"
    //     : "#f7954c",
    backgroundColor: bgColor,
    // color: text?.toLowerCase() === CANCEL?.toLowerCase() ? "#000" : "#fff",
    color: color,
    opacity: text?.toLowerCase() === CANCEL?.toLowerCase() ? 0.65 : "",
    fontSize: "16px",
    fontWeight: 600,
    letterSpacing: "-0.02em",
    fontFamily: "Montserrat",
    "&:hover": {
      // backgroundColor:
      //   text?.toLowerCase() === CANCEL?.toLowerCase()
      //     ? "#d8d8d8"
      //     : text?.toLowerCase() === LOG_OUT?.toLowerCase()
      //     ? "#e51818"
      //     : "#f7954c",
      backgroundColor: bgColor,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      color: color,
      backgroundColor: bgColor,
      opacity: 0.65,
    },
  };

  const outlinedBtn = {
    width: width ? width : "auto",
    height: height ? height : "auto",
    textTransform: "capitalize",
    border: `1px solid ${color}`,
    backgroundColor: bgColor,
    fontSize: "16px",
    fontWeight: 600,
    letterSpacing: "-0.02em",
    fontFamily: "Montserrat",
    color: color,
    textAlign: "center",
    "&:hover": {
      background: "transparent",
      border: `1px solid ${color}`,
    },
  };

  const textBtn = {
    width: width ? width : "auto",
    height: height ? height : "auto",
    fontSize: "16px",
    fontWeight: 600,
    letterSpacing: "-0.02em",
    fontFamily: "Montserrat",
    textTransform: "capitalize",
    // color:
    //   (text?.toLowerCase() === MARK_AS_ADMIN?.toLowerCase() && "#2db29e") ||
    //   (text?.toLowerCase() === EDIT?.toLowerCase() && "#000") ||
    //   (text?.toLowerCase() === REMOVE?.toLowerCase() && "#e51818"),
    color: color || "",
    "&:hover": {
      background: "transparent",
    },
  };

 const variantStyles =
  (variant === "contained" && containedBtn) ||
  (variant === "outlined" && outlinedBtn) ||
  (variant === "text" && textBtn) ||
  {};

const custom_styles = {
  ...variantStyles,
  ...sx
};
  return (
    <Button
      sx={custom_styles}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {text}
      {children}
    </Button>
  );
};

export default ButtonCta1;
